import axiosInstance from './axiosInstance';

export type RecruitmentReportBucket = 'week' | 'month';

export interface RecruitmentReportingPeriod {
    periodStart: string;
    registrations: number;
    suitable: number;
    offered: number;
    placed: number;
    placementStarts?: number;
    registrationToPlacementConversion: number;
}

export interface RecruitmentReportingBreakdown {
    key: string;
    registrations: number;
    placed: number;
}

export interface RecruitmentReportingResponse {
    from: string;
    to: string;
    bucket: RecruitmentReportBucket;
    conversionDefinition: string;
    timeline: RecruitmentReportingPeriod[];
    byProfession: RecruitmentReportingBreakdown[];
    byCountry: RecruitmentReportingBreakdown[];
}

export interface RecruitmentReportingQuery {
    from: string;
    to: string;
    bucket: RecruitmentReportBucket;
}

export async function fetchRecruitmentReport(query: RecruitmentReportingQuery): Promise<RecruitmentReportingResponse> {
    const response = await axiosInstance.get<RecruitmentReportingResponse>('/reporting/recruitment', { params: query });
    return response.data;
}

export async function downloadRecruitmentReportCsv(query: RecruitmentReportingQuery): Promise<void> {
    const response = await axiosInstance.get<Blob>('/reporting/recruitment/export.csv', {
        params: query,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = `recruitment-report-${query.from}-${query.to}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
